"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var PlainButton_1 = __importDefault(require("../buttons/PlainButton"));
var padLeft = function (value) { return ("0" + value).slice(-2); };
var timeSelectOptions = [];
for (var hours = 0; hours < 24; hours += 1) {
    for (var minutes = 0; minutes < 60; minutes += 15) {
        var meridian = hours < 12 ? "AM" : "PM";
        timeSelectOptions.push({
            hours: hours,
            minutes: minutes,
            label: padLeft(hours % 12 || 12) + ":" + padLeft(minutes) + " " + meridian
        });
    }
}
var TimeSelectButton = function (_a) {
    var currentOptionRef = _a.currentOptionRef, hours = _a.hours, minutes = _a.minutes, onChange = _a.onChange, option = _a.option;
    var current = hours === option.hours && minutes === option.minutes;
    return (react_1.default.createElement(PlainButton_1.default, { "aria-current": current, className: "chq-tsl--op", onClick: function () { return onChange(option.hours, option.minutes); }, ref: current ? currentOptionRef : null }, option.label));
};
var TimeSelect = function (_a) {
    var hours = _a.hours, minutes = _a.minutes, onChange = _a.onChange;
    var currentOptionRef = react_1.useRef(null);
    var selectRef = react_1.useRef(null);
    react_1.useEffect(function () {
        var currentOption = currentOptionRef.current;
        var select = selectRef.current;
        if (currentOption && select) {
            select.scrollTop = Math.max(0, currentOption.offsetTop - select.offsetTop - 46);
        }
    }, [currentOptionRef, selectRef]);
    return (react_1.default.createElement("div", { className: "chq-tsl", ref: selectRef }, timeSelectOptions.map(function (option) { return (react_1.default.createElement(TimeSelectButton, { key: option.hours + ":" + option.minutes, currentOptionRef: currentOptionRef, hours: hours, minutes: minutes, onChange: onChange, option: option })); })));
};
exports.default = TimeSelect;
